/**
 * Created by slava on 4/12/17.
 */

cleverapps.RestClient = {
    METHODS: {
        GET: "GET",
        POST: "POST",
        DELETE: "DELETE"
    },

    getDefaultTimeout: function () {
        return window.connector && connector.platform.oneOf(connector.WECHAT) ? 20000 : 10000;
    },

    getXMLHttpRequest: function () {
        return typeof XMLHttpRequest !== "undefined" ? new XMLHttpRequest() : new ActiveXObject("MSXML2.XMLHTTP");
    },

    get: function (path, data, onSuccess, onError, options) {
        this.send(this.METHODS.GET, path, data, onSuccess, onError, options);
    },

    post: function (path, data, onSuccess, onError, options) {
        this.send(this.METHODS.POST, path, data, onSuccess, onError, options);
    },

    delete: function (path, data, onSuccess, onError, options) {
        this.send(this.METHODS.DELETE, path, data, onSuccess, onError, options);
    },
    
    send: function (httpMethod, path, data, onSuccess, onError, options) {
        options = options || {};

        if (cleverapps.flags && cleverapps.flags.norest && !options.ignoreNoRest) {
            onError && onError({ errorMessage: "Rest is not available for this platform" });
            return;
        }

        if (connector.config.norest && !options.ignoreNoRest && !path.startsWith("http")) {
            onError && onError({ errorMessage: "Rest is not running" });
            return;
        }

        data = data || {};

        const timeout = options.timeout || this.getDefaultTimeout();
        const fullPath = path.indexOf("http") !== 0 && path.indexOf("/.proxy/") !== 0 && !options.fullPath && !path.startsWith("/api/proxy")
            ? cleverapps.config.restApiURL + path : path;
        let reqListener;

        const oReq = this.getXMLHttpRequest();

        let errorTimeout = setTimeout(() => {
            reqListener.call({
                status: -1,
                responseText: "our timeout"
            });
        }, timeout + 1000);

        reqListener = function () {
            if (errorTimeout !== undefined) {
                clearTimeout(errorTimeout);
                errorTimeout = undefined;
            }
            if (this.status >= 200 && this.status < 300) {
                if (onSuccess) {
                    let success = true;
                    let json;

                    try {
                        json = this.responseText && JSON.parse(this.responseText);
                    } catch (e) {
                        success = false;
                        cleverapps.throwAsync(`parse json error path - ${path} error - ${e.message} text - ${this.responseText}`);
                    }

                    if (success) {
                        onSuccess(json);
                    } else if (onError) {
                        onError(this);
                    }
                }
            } else {
                if (this.responseText) {
                    this.errorMessage = (this.responseText.split("\n")[0] || "").trim();
                }

                console.log("XMLHttpRequest FAILED", httpMethod, this.status, this.errorMessage, fullPath);

                if (onError) {
                    onError(this);
                }
            }

            onSuccess = function () {};
            onError = function () {};
        }.bind(oReq);

        oReq.ontimeout = reqListener;
        oReq.onload = reqListener;
        oReq.onerror = reqListener;
        oReq.onabort = reqListener;

        oReq.open(httpMethod, fullPath);
        oReq.timeout = timeout;

        oReq.setRequestHeader("Content-Type", "application/json");
        if (cleverapps.config.debugMode && cleverapps.debugCountry) {
            oReq.setRequestHeader("X-Debug-Country", cleverapps.debugCountry);
        }

        if (window.devvit && window.devvit.token) {
            oReq.setRequestHeader("authorization", `Bearer ${window.devvit.token}`);
        } else if (options.authorization) {
            oReq.setRequestHeader("authorization", options.authorization);
        } else {
            oReq.setRequestHeader("Cache-Control", "no-cache");
        }

        oReq.send(JSON.stringify(data));
    },

    sendRaw: function (httpMethod, path, rawData) {
        const oReq = this.getXMLHttpRequest();

        oReq.open(httpMethod, path);
        oReq.timeout = this.getDefaultTimeout();

        if (window.devvit && window.devvit.token) {
            oReq.setRequestHeader("authorization", `Bearer ${window.devvit.token}`);
        }

        oReq.send(rawData);
    },

    standsWeb: function (url) {
        url = url || "";
        return cleverapps.config.deployment + url;
    },

    standsRest: function (url) {
        url = url || "";
        return `${cleverapps.config.deployment}/${cleverapps.config.name}-rest${url}`;
    }
};
